import { render, staticRenderFns } from "./LoanButtonGroup.vue?vue&type=template&id=3f48a078&"
import script from "./LoanButtonGroup.vue?vue&type=script&lang=js&"
export * from "./LoanButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports